import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
    selector: '[window-type-8]',
    templateUrl: './window-type-8.component.html',
    styleUrl: './window-type-8.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WindowType8Component {
  public height = input<number>();

  public leftWindowPositions = computed(() => 
    this.generateWindows({
      height: this.height(),
      columns: 10,
      initialX: 10,
      initialY: 65,
      xStep: 8,
      yStep: 5,
      rowOffset: 20,
      isLeft: true
    })
  );
  
  public rightWindowPositions = computed(() => 
    this.generateWindows({
      height: this.height(),
      columns: 10,
      initialX: 108,
      initialY: 110,
      xStep: 8,
      yStep: 5,
      rowOffset: 20,
      isLeft: false // Default is true, so explicitly setting it false
    })
  );
  

  private generateWindows(config: {
    height: number;
    columns: number;
    initialX: number;
    initialY: number;
    xStep: number;
    yStep: number;
    rowOffset: number;
    isLeft?: boolean;
  }) {
    const { height, columns, initialX, initialY, xStep, yStep, rowOffset, isLeft = true } = config;
    const rows = Math.ceil(height / 60);
  
    return Array.from({ length: rows }, (_, row) =>
      Array.from({ length: columns }, (_, col) => ({
        x: initialX + col * xStep,
        y: initialY + row * rowOffset + (isLeft ? col * yStep : -col * yStep),
      }))
    );
  }
  

  public trackByIndex = (index: number) => index;
}
